import React, { useState, useEffect, useCallback } from 'react';
import { CheckCircle, Warning, Info, X } from '@phosphor-icons/react';

const icons = {
  success: <CheckCircle size={18} weight="fill" color="#16a34a" />,
  error: <Warning size={18} weight="fill" color="#dc2626" />,
  info: <Info size={18} weight="fill" color="#1D4ED8" />,
};

const bgColors = {
  success: '#f0fdf4',
  error: '#fef2f2',
  info: '#eef2ff',
};

const borderColors = {
  success: '#bbf7d0',
  error: '#fecaca',
  info: '#c7d2fe',
};

let toastId = 0;
let globalShow = null;

export function showToast(message, type = 'success') {
  if (globalShow) globalShow(message, type);
}

export function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, message, type, entering: true }]);
    setTimeout(() => setToasts(prev => prev.map(t => t.id === id ? { ...t, entering: false } : t)), 10);
    setTimeout(() => setToasts(prev => prev.map(t => t.id === id ? { ...t, leaving: true } : t)), 3000);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3400);
  }, []);

  useEffect(() => { globalShow = show; return () => { globalShow = null; }; }, [show]);

  const dismiss = (id) => {
    setToasts(prev => prev.map(t => t.id === id ? { ...t, leaving: true } : t));
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 400);
  };

  return (
    <div style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 9999, display: 'flex', flexDirection: 'column-reverse', gap: 8, pointerEvents: 'none' }}>
      {toasts.map(toast => (
        <div
          key={toast.id}
          style={{
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '12px 16px',
            backgroundColor: bgColors[toast.type] || bgColors.info,
            border: `1px solid ${borderColors[toast.type] || borderColors.info}`,
            borderRadius: 10,
            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
            minWidth: 260,
            maxWidth: 380,
            transform: toast.entering ? 'translateX(120%)' : toast.leaving ? 'translateX(120%)' : 'translateX(0)',
            opacity: toast.leaving ? 0 : 1,
            transition: 'transform 0.35s cubic-bezier(0.16,1,0.3,1), opacity 0.3s ease',
          }}
        >
          {icons[toast.type] || icons.info}
          <span style={{ flex: 1, fontSize: 13, fontWeight: 500, color: '#1f2937', lineHeight: 1.4 }}>
            {toast.message}
          </span>
          <button
            onClick={() => dismiss(toast.id)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 2, color: '#9ca3af', flexShrink: 0 }}
          >
            <X size={14} />
          </button>
        </div>
      ))}
    </div>
  );
}
